import * as React from "react";
import {Card, CardMedia} from "material-ui/Card";
import styles = require("./style.less");
import {FormSectionBase, FormSectionBaseProps} from "components/form/Sections/FormSectionBase";

// like Unstructured form section with no margin so warnings fill the panel
class WarningFormSection extends FormSectionBase<FormSectionBaseProps> {
    render() {
        return <Card
            className={styles.formNonExpander}
            expanded={true}>
            {this.body(styles.cardMediaWarning, false)}
        </Card>;
    }
}

export default WarningFormSection;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/Sections/WarningFormSection.tsx